export const setActiveLocation = (payload) => (dispatch) => {
  dispatch({
    type: 'SET_ACTIVE_LOCATION',
    payload,
  });
};
